module.exports = __webpack_public_path__ + "img/computer.b30bcd80.svg";